import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const ITEMS = [
  { q: "I have zero sales experience. Will this work?",
    a: "Yes. Most of the room started with zero. The frameworks and the reps are built for that starting point. By the time you go for a real offer, you've already drilled more live reps than most people get in their first year doing it alone." },
  { q: "How is this different from Cole Gordon / Iman / Remote Closing Academy?",
    a: "Most programs end with you \"ready to apply\" and a login that expires. This one trains you to closer standard, keeps the room open while you build, and opens a direct line to real offers when you're ready. We don't run on a 90-day clock. We work until you can hold your own on a real call." },
  { q: "What if I'm working a full-time job right now?",
    a: "Most people in the room are. The 1-on-1s are scheduled around you. The AI trainer runs whenever you have 30 minutes. You build the skill on the side first, then move when you're ready. Nobody's telling you to quit your job in week one." },
  { q: "When do I actually get placed on an offer?",
    a: "Honestly? When you're ready, and that's rarely in the first 90 days. The offers we put you in front of have a bar you have to pass, and most people aren't there overnight. For a lot of operators it's a few months in. We don't sell you a placement date. We open the door and keep working with you until you walk through it." },
  { q: "What's the investment?",
    a: "Discussed on the call so we can structure it to your situation. We don't hide the number. We just don't anchor it on a page. The call is where we confirm fit and figure out the structure that works." },
  { q: "Is there a payment plan?",
    a: "Yes. We'll cover the structure on the call." },
  { q: "What happens on the call?",
    a: "A real conversation about where you are, what's stopping you, and whether the program fits. No hard sell. If it's a fit, we discuss the structure. If it isn't, we tell you straight and save both of us the time." },
];

export default function FAQ() {
  return (
    <section id="faq" className="access-section">
      <span className="gold-rule-v" aria-hidden />
      <div className="access-container max-w-3xl">
        <span className="mono-label mono-label-gold">What you might be wondering</span>
        <h2 className="h-section mt-6">Questions <span>before the call.</span></h2>
        <Accordion type="single" collapsible className="mt-12">
          {ITEMS.map((it, i) => (
            <AccordionItem key={i} value={`i-${i}`} className="border-b last:border-b-0" style={{ borderColor: "var(--rule)" }}>
              <AccordionTrigger className="text-left font-display text-bone text-xl md:text-[1.4rem] py-7 hover:no-underline" style={{ fontVariationSettings: '"opsz" 96, "SOFT" 30', fontWeight: 500 }}>
                <span className="flex items-baseline gap-5">
                  <span className="font-mono text-[10px] tracking-[0.22em] text-gold">{String(i + 1).padStart(2, "0")}</span>
                  <span>{it.q}</span>
                </span>
              </AccordionTrigger>
              <AccordionContent className="text-dim text-[16px] leading-[1.7] pb-7 pl-10">
                {it.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
